import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class DepartmentStore {
  departments = [];

  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      total: observable,
      loading: observable,
      departments: observable,
      getUserDepartmentData: action,
      getDepartmentData: action,

      addDepartment: action,
    });
    this.rootStore = rootStore;
  }

  async getDepartmentData() {
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=salesperson&a=getDepartment");

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/department/getDepartment");
    var allDepartment = [{ departmentId: "0", departmentName: "All" }];

    allDepartment = [...allDepartment, ...response?.data?.data];

    this.departments = allDepartment;
  }

  async getUserDepartmentData() {
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=salesperson&a=getDepartment");
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/department/getDepartment");
    this.departments = response?.data?.data;
  }

  // async addDepartment(departmentDetails) {
  //   var postData = departmentDetails;
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=salesperson&a=addDepartment",
  //       "postData=" + base64Input
  //     );
  //   return response;
  // }

  async addDepartment(departmentDetails) {
    var postData = departmentDetails;
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/department/addDepartment", {
        postData,
      });
    return response;
  }
}

export default DepartmentStore;
